/**
 * @module Banners - Headline Banner
 * @description Headline banner
 */
import PropTypes from 'prop-types';
import { stringify } from '@/js/utils/filters';
import dynamic from 'next/dynamic';
import { trackEvent } from '@/js/helpers/tracking';
import styles from './BannerHeadline.module.css';

const Link = dynamic( () => import( 'next/link' ), { ssr: false } );

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const {
    title = 'Limited time offer',
    subtitle = 'Lorem Ipsum',
    theme = null,
    isCentered = false,
    ctaCopy,
    ctaUrl
  } = props;

  /**
   * @function handleClick
   * @description fire off tagular events
   */
  const handleClick = ( event ) => {
    const { target } = event;
    const payload = JSON.parse( target.getAttribute( 'data-payload' ) );
    const { text, actionOutcome, position } = payload;

    const data = {
      elementType: 'BUTTON',
      location: 'Banner',
      position,
      text,
      actionOutcome
    };

    trackEvent( { action: 'elementClicked', data, event } );
  };

  return (
    <section className={ `component ${ styles.component } ${ theme && `u-theme-${ theme }` }` }>
      <div className="l-container">
        <div className={ `${ styles.component__body } ${ isCentered && styles.component__bodyCentered }` }>
          <p className={ `h5 ${ styles.component__title } ${ theme && styles[ `component__title__${ theme }` ] } ` }>{ title }</p>
          <p className={ `${ styles.component__subtitle } ${ isCentered && styles.component__subtitleCentered }` }>{ subtitle }</p>

          { ctaCopy && ctaUrl &&
            <Link
              className={ styles.component__ctaLink }
              href={ ctaUrl }
              onClick={ handleClick }
              data-payload={ stringify( {
                text: ctaCopy,
                position: 'Banner',
                actionOutcome: 'INTERALLINK'
              } ) }>
              { ctaCopy }
            </Link>
          }
        </div>{ /* <!-- .component__body --> */ }
      </div>
    </section>
  );
};

Component.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  theme: PropTypes.string,
  isCentered: PropTypes.bool
};

export default Component;
